import { VueIntegrationOptions } from '@sentry/vue';
import * as Sentry from '@sentry/vue';
import { watch } from 'vue';
import useSession from '@/composables/useSession';

export function configureSentryUser(): void {
    const { taskConfig } = useSession();

    watch(
        () => taskConfig.value?.student_id,
        (studentId) => {
            Sentry.setUser(studentId ? { id: studentId } : null);

            // console.log(studentId ? `[Sentry] User identified: ${studentId}` : '[Sentry] User context cleared.');
        }
    );
}

export default function initSentry(app?: VueIntegrationOptions['Vue']) {
    Sentry.init({
        app,

        dsn: process.env.VUE_APP_SENTRY_DSN,

        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,

        release: process.env.VUE_APP_SENTRY_RELEASE,

        replaysSessionSampleRate: process.env.VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE ?? 0.1,
        replaysOnErrorSampleRate: process.env.VUE_APP_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE ?? 1.0,

        tracesSampleRate: process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.1,

        tracePropagationTargets: [
            'localhost',
            /^https:\/\/onae.mobilethinking\.ch/,
            /^https:\/\/onae.dexio\.ch/,
            /^https:\/\/onae.ciip\.ch/,
            /^https:\/\/manageronae.ciip\.ch/,
        ],

        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserSessionIntegration(),
            Sentry.replayIntegration({
                maskAllText:
                    String(process.env.VUE_APP_SENTRY_REPLAY_INTEGRATION_MASK_ALL_TEXT).toLowerCase() === 'true', // False by default
                blockAllMedia:
                    String(process.env.VUE_APP_SENTRY_REPLAY_INTEGRATION_BLOCK_ALL_MEDIA).toLowerCase() !== 'false', // True by default
            }),
            Sentry.replayCanvasIntegration(),
        ],
    });

    configureSentryUser();
}
